import { useMutation } from '@tanstack/react-query';
import ProductApiV2 from '../../lib/api/product/ProductApiV2';
import { ProductsExcelUploadResponseDto } from '../../types/api/products';
import toastMsg from '../../lib/toastMsg';
import { ResponseError } from '../../types/common/api';
import { extractErrorMessage } from '../../lib/utils/checkErrorResponse';

interface ProductListExcelProps {
  onUploadSuccess: (res: ProductsExcelUploadResponseDto) => void;
}
export const useProductListExcel = (props: ProductListExcelProps) => {
  const { onUploadSuccess } = props;
  const { mutate: uploadProductListExcel } = useMutation(ProductApiV2.uploadExcel, {
    onSuccess: onUploadSuccess,
    onError: (error: ResponseError) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });
  const { mutate: downloadProductListExcel } = useMutation(ProductApiV2.downloadExcel, {
    onSuccess: ({ adminEmail }) => {
      toastMsg.success(`${adminEmail}로 엑셀이 발송되었습니다`);
    },
  });

  return { uploadProductListExcel, downloadProductListExcel };
};
